var CDropdownItemView = Backbone.View.extend({

    tagName: 'option',

    initialize:function( options )
    {
        this.valueField = options.valueField || '';
        this.textField = options.textField || '';
        this.template= kendo.template('${' + this.textField + '}');
        this.selected = options.selected || false;
    },

    render:function()
    {
        this.$el.html(this.template(this.model.toJSON()));
        this.$el.attr('value', this.model.get( this.valueField ));
        this.$el.attr('data-id', this.model.id);
        if (this.selected)
        {
            this.$el.prop('selected', true);
        }
        return this;
    }
});